import { Controller, useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, MenuItem, TextField, } from "@material-ui/core";
import { basic, validationMessages, requiredOnlyMessage, requiredOnly } from '../../../config/validations';
import { userTriggerEventsList, mainTransInAlphabeticalOrder, fetchSelectedUserTrigger } from "../../../services/entities/user_triggers";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { invokePostService, invokeGetService, toggleRightDrawer } from "../../../store/global/actions";
import { handleSnackBar } from '../../../store/global/actions';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress.js';
import { validateNonAsciiChars } from "../../../utils/commonUtils.js";
import SkeletonLoader from "../../atoms/loader/SkeletonLoader.js";
import ExtendUTFields from "./ExtendUTFields.js";



export default function EditUserTrigger(props) {

    const { onCompletion, onClose, userTriggerId, tag } = props;
    const dispatch = useDispatch();

    // const transactions = useSelector(getTransInAlphabeticalOrder);
    const [transactions, setTransactions] = useState([])

    // const mainTransactionsOnly = useSelector(getMainTransInAlphabeticalOrder)
    const [mainTransactionsOnly, setMainTransaction] = useState([])
    const [allEvents, setAllEVents] = useState([])
    const [allTransactions, setAllTrans] = useState([])
    const [allUserTriggers, setAllUserTriggers] = useState([])
    const [allFields, setAllFields] = useState([])
    const [clusterlets, setClusterlets] = useState([])
    const [loading, setLoading] = useState(false);
    // const selectedUserTrigger = useSelector(getSelectedUserTrigger({ userTriggerId })).
    const [selectedUserTrigger, setSelectedUt] = useState(null)

    // const userTriggerEvents = userTriggerEventsList({ transaction: selectedUserTrigger.transaction.id, delegate: selectedUserTrigger.delegate, allEvents, allTransactions, allUserTriggers, selectedUtEvent: selectedUserTrigger.attributes.op })
    const [userTriggerEvents, setUserTriggerEventList] = useState([])
    const [events, setEvents] = useState([]);

    // const destClusterlet = clusterlets.find(clusterlet => clusterlet.id === selectedUserTrigger?.attributes?.type)
    const [destClusterlet, setDestClusterlet] = useState(null)

    // const transaction = selectedUserTrigger.transaction.id;
    // const event = selectedUserTrigger.attributes.op;
    // const type = clusterlets.find(clusterlet => clusterlet.id === selectedUserTrigger.attributes.type).name

    const [transaction, setTransaction] = useState('');
    const [event, setEvent] = useState('');
    const [type, setType] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [utExtensionFileds, setUTExtensionFileds] = useState(null);

    const { register, handleSubmit, formState: { errors }, control, getValues, setValue, reset } = useForm({
        defaultValues: {
            transaction,
            event,
            // name: selectedUserTrigger.name,
            description: selectedUserTrigger?.attributes?.desc ? selectedUserTrigger?.attributes?.desc : "",
            // instance: selectedUserTrigger.field.name,
            // instanceDesc: selectedUserTrigger.field.attributes.desc ? selectedUserTrigger.field.attributes.desc : "",
            type
        }
    });

    useEffect(() => {
        setLoading(true);
        dispatch(invokeGetService('getSingleUT', [userTriggerId]))
            .then((response) => {
                setLoading(false);
                if (response.data !== undefined) {
                    console.log('respppp------>', response)
                    setClusterlets(response.data.clusterlets)
                    setAllEVents(response.data.events)
                    setTransactions(mainTransInAlphabeticalOrder(response.data.transactions));
                    setMainTransaction(mainTransInAlphabeticalOrder(response.data.transactions))
                    setAllTrans(response.data.transactions)
                    setAllUserTriggers(response.data.userTriggers)
                    setAllFields(response.data.fields)

                    let selUT = fetchSelectedUserTrigger({ userTriggerId, userTriggers: response.data.userTriggers, events: response.data.events, transactions: response.data.transactions, fields: response.data.fields })
                    console.log('selUT-------->', selUT)
                    console.log('only-------', mainTransInAlphabeticalOrder(response.data.transactions))
                    setSelectedUt(selUT)

                    let uTEventLIst = userTriggerEventsList({ transaction: selUT.transaction._id, delegate: selUT.delegate, allEvents: response.data.events, allTransactions: response.data.transactions, allUserTriggers: response.data.userTriggers, selectedUtEvent: selUT.attributes.op })
                    setEvents(uTEventLIst)

                    setDestClusterlet(response.data.clusterlets.find(clusterlet => clusterlet._id == selUT?.attributes?.type))


                    setTransaction(selUT.transaction._id)
                    setEvent(selUT.attributes.op)
                    setType(response.data.clusterlets.find(clusterlet => clusterlet._id == selUT.attributes.type)?.name)
                    // setValue('transaction', '64667db84512cb12567c3156')


                }
            })
    }, [userTriggerId])

    useEffect(() => {
        reset({
            transaction: selectedUserTrigger?.transaction?._id ? selectedUserTrigger?.transaction?._id : '', event, description: selectedUserTrigger?.attributes?.desc ? selectedUserTrigger?.attributes?.desc : "", type
        })
    }, [transaction, type, event])




    const messages = {
        ...requiredOnlyMessage,
        ...validationMessages,
        maxLength: 'Description cannot exceed 200 characters'
    }

    const populateEvents = () => {
        const { transaction } = getValues();

        const userTriggerEvents = userTriggerEventsList({ transaction, delegate: selectedUserTrigger.delegate, allEvents, allTransactions, allUserTriggers, selectedUtEvent: event })
        setEvents(userTriggerEvents)
    }

    const listenChange = () => {
        const { transaction } = getValues();

        if (transaction === undefined || transaction === "") {
            setEvents([])
            setValue("description", "")
            setValue("event", "")
            return
        } else {
            populateEvents()
        }
    }

    const listenEvent = () => {
        const { event } = getValues();

        if (event === undefined || event === "") {
            setValue("description", "")
            return
        }
        else {
            const eventData = allEvents.find(item => item._id == event)
            const clusterlet = clusterlets.find(clusterlet => clusterlet._id == eventData.dst);
            setValue("name", eventData.name);
            setValue("type", clusterlet.name);
            setValue("description", eventData.desc);
        }
    }


    const onUpdate = ({ transaction, event, /*name,*/ description, /*instance,*/ instanceDesc }) => {
        setIsEditing(true)
        const selectedEvent = allEvents.find(item => item._id == event)
        const userTriggerType = clusterlets.find(item => item._id == selectedEvent.dst);
        const userTrigger = allUserTriggers.find(item => item._id == userTriggerId)
        const field = allFields.find(item => {
            const parents = item.parent.map(item => item.id)
            if (parents.includes(userTriggerId)) return item
        })
        const instanceName = userTriggerType.name.toLowerCase();

        const updatedUserTrigger = {
            ...userTrigger,
            // name,
            attributes: {
                ...userTrigger.attributes,
                op: event,
                desc: description,
                type: userTriggerType._id
            }
        }

        const updatedField = {
            ...field,
            // name: instance,
            name: `${instanceName}_Name`,
            attributes: {
                ...field.attributes,
                // desc: instanceDesc
            }
        }

        // const payloadForUndoRedo = {
        //     item: updatedUserTrigger,
        //     original: userTrigger,
        //     originalFields: [field],
        //     editedFields: [updatedField]
        // }

        // dispatch(dealWithUserTriggers(payloadForUndoRedo, 'edit'))

        // dispatch(editUserTrigger(updatedUserTrigger, true))
        // dispatch(editField(updatedField, true))

        if(utExtensionFileds != undefined && Array.isArray(utExtensionFileds)){
            updatedUserTrigger.extensions = utExtensionFileds;
        }


        dispatch(invokePostService('editUserTrigger', { userTriggerData: updatedUserTrigger }, [selectedUserTrigger._id]))
            .then(savedData => {
                if (savedData.status) {
                    onCompletion('User trigger', 'edit');

                }
                else if (savedData.status == false && savedData.code == 255) {
                    dispatch(toggleRightDrawer());

                }
                else {
                    dispatch(handleSnackBar({ open: true, message: savedData.message, severity: "error" }));
                }
                setIsEditing(false)
            })
            .catch(error => console.error(error));


    }


    return (
        <>
            {loading && <SkeletonLoader type="form" rows={2} grid={[2,2]} />}

{
!loading  &&
<Grid id={"edit_usertrigger_form"} container direction={"row"} spacing={3}>
    <Grid item xs={6}>
        <Controller
            name="transaction"
            control={control}
            rules={{ required: true, requiredOnly }}
            defaultValue={transaction}
            render={({ field, value, onChange }) =>
                <TextField
                    {...field}
                    autoFocus
                    disabled={tag === "event" ? true : false}
                    label={'Transaction Name'}
                    select
                    fullWidth
                    required
                    value={value}
                    variant={'outlined'}
                    onChange={e => { onChange(e); listenChange(e) }}
                    error={errors?.transaction ? true : false}
                    helperText={messages[errors?.transaction?.type] || ''}
                >
                    <MenuItem key={123} value={""}>Select</MenuItem>
                    {mainTransactionsOnly.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            }
        />
    </Grid>

    <Grid item xs={6}>
        <Controller
            name="event"
            control={control}
            rules={{ required: true, requiredOnly }}
            defaultValue={event}
            render={({ field, value, onChange }) =>
                <TextField
                    {...field}
                    name="event"
                    label={"Event Name"}
                    disabled={tag === "event" ? true : false}
                    fullWidth
                    required
                    select
                    variant="outlined"
                    onChange={e => { onChange(e); listenEvent(e) }}
                    value={value}
                    error={errors?.event ? true : false}
                    helperText={messages[errors?.event?.type] || ''}
                >
                    <MenuItem key={123} value={""}>Select</MenuItem>
                    {events.map((option) => (
                        <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            }
        />
    </Grid>

    {/* <Grid item xs={12}>
        <TextField
            name="name"
            label={"Name"}
            fullWidth
            type={"text"}
            required
            variant="outlined"
            inputRef={register({ ...basic })}
            error={errors?.name ? true : false}
            helperText={messages[errors?.name?.type] || ''}

        />
    </Grid> */}

    <Grid item xs={6}>
        <TextField
            name="description"
            label={"Description"}
            fullWidth
            variant="outlined"
            type={"text"}
            // multiline
            // rows={2}
            // maxRows={2}
            inputRef={register({ required: true, maxLength: 200, validate: validateNonAsciiChars })}
            error={errors?.description ? true : false}
            helperText={errors?.description?.message || messages[errors?.description?.type] || ''}
            InputLabelProps={{ shrink: true }}
        />
    </Grid>

    <Grid item xs={6}>
        <TextField
            name="type"
            label={"Target"}
            type={"text"}
            required
            fullWidth
            variant="outlined"
            inputRef={register({ ...basic })}
            disabled
            InputLabelProps={{ shrink: true }}
        //defaultValue={destClusterlet?.name}
        />
    </Grid>

    {/* <Grid item xs={6}>
        <TextField
            name="instance"
            label={"Instance Name"}
            type={"text"}
            required
            fullWidth
            variant="outlined"
            inputRef={register({ ...basic })}
            error={errors?.instance ? true : false}
            helperText={messages[errors?.instance?.type] || ''}
        />
    </Grid> */}

    {/* <Grid item xs={4}>
        <TextField
            name="type"
            label={"Instance Type"}
            type={"text"}
            placeholder={""}
            fullWidth
            required
            variant="outlined"
            inputRef={register({...numberOnly})}
            error={ errors?.code ? true : false }
            helperText={ errors?.code ? messages[errors?.code?.type]: '' }
        />
    </Grid> */}

    {/* <Grid item xs={12}>
        <TextField
            name="instanceDesc"
            label={"Instance Description"}
            fullWidth
            inputRef={register}
            type={"text"}
            variant="outlined"
            multiline={true}
            rows={4}
        />
    </Grid> */}

    <Grid item xs={12} id={"usertrigger_message_fields"}>
        {tag === "event" && <ExtendUTFields userTriggerId={userTriggerId} onClose={onClose} onCompletion={onCompletion} setUTExtensionFileds={setUTExtensionFileds}/>}
    </Grid>

    <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
        <UpdateCancel forceCancel onUpdate={handleSubmit(onUpdate)} cancelText='Back' onCancel={onClose} updateDisable={isEditing} content={isEditing ? 'Updating..' : 'Update'} typesNotIn={['transaction', 'view']} hideCancel={tag=="event" ? true :false}/>
    </Grid>

</Grid>
}

        </>
    );
}
